import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface bookingState {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: bookingState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const bookingSlice = createSlice({
  name: 'bookings',
  initialState,
  reducers: {
    setBookings: (state, action) => {
      state.totalRecords = action.payload.totalRecords;
      state.data = action.payload.data;
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
    },
    addNewbooking: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setBookings, addNewbooking, reset } = bookingSlice.actions;

// selectors
export const getbookingSpaces = (state: RootState) => state.bookings.data;
export const getBookingTotalRecords = (state: RootState) => state.bookings.totalRecords;

export default bookingSlice.reducer;
